import { CountryModel } from './country.model';
import { SiteModel } from './site.model';

export class UserModel {
  Id: number;
  Name: string;
  EmailAddress: string;
  IsAdmin: boolean;
  Upn: string;
  Mobile: string;
  Country: CountryModel;
  CountryId: number;
  Sites: SiteModel[] = [];

  // for UI views
  IsSelected?: boolean;
}
